import React from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { useTranslation } from '../../../utils/i18n';
import './StepStyles.css';

const Step5Dates = ({ formData, setFormData }) => {
  const { language } = useAuth();
  const { t } = useTranslation(language);
  const days = Array.from({ length: 28 }, (_, i) => i + 1);
  const popularDays = [5, 10, 15, 20, 25];

  const handleDateChange = (value) => {
    const dayValue = parseInt(value);
    setFormData((prev) => ({
      ...prev,
      paymentDate: dayValue,
      // Set both interest and principal to same date for backend compatibility
      interestPaymentDate: dayValue,
      principalPaymentDate: dayValue,
    }));
  };

  return (
    <div className="step-container">
      <div className="form-group">
        <label className="form-label">
          {t('paymentDateMonthly')} <span className="required">*</span>
        </label>
        <select
          value={formData.paymentDate || formData.interestPaymentDate || ''}
          onChange={(e) => handleDateChange(e.target.value)}
        >
          <option value="">{t('selectDate')}</option>
          {days.map((day) => (
            <option key={day} value={day}>
              {t('dayOfMonthLabel').replace('{day}', day)}
            </option>
          ))}
        </select>

        {/* <div className="quick-select">
          <p className="quick-select-label">{t('popularDays')}:</p>
          <div className="quick-buttons">
            {popularDays.map((day) => (
              <button
                key={day}
                type="button"
                className={`quick-btn ${
                  (formData.paymentDate === day || formData.interestPaymentDate === day) ? 'active' : ''
                }`}
                onClick={() => handleDateChange(day)}
              >
                {t('dayLabel').replace('{day}', day)}
              </button>
            ))}
          </div>
        </div> */}
      </div>

      <div className="step-info">
        💡 <strong>{t('notePaymentDate')}:</strong>
        <ul>
          <li>{t('notePaymentDateItem1')}</li>
          <li>{t('notePaymentDateItem2')}</li>
        </ul>
      </div>

      {!(formData.paymentDate || formData.interestPaymentDate) && (
        <div className="step-info warning">
          ⚠️ {t('selectPaymentDate')}
        </div>
      )}
    </div>
  );
};

export default Step5Dates;
